/**
 * This file contains constants related to the project in general. If you decide that certain
 * constants should be moved to a file that's more specific, feel free to do so. Just be sure
 * to update any existing references when you do.
 * 
 * All constants should be UPPERCASE.
 * All constants should be defined as const rather than let
 * All constants should be in alphabetical order.
 * All constants should be exported so other files can easily use them.
 * 
 * In ES6 and onward, semicolons are optional. They have been omitted in this file.
 */

export const DEV_ENVIRONMENT = 'dev'
export const DEV_DOMAIN = 'canvasprints.local'
export const DEV_FRONTEND_PORT = 9292
export const DEV_API_PORT = 3000
export const LOOPBACK_IP = '127.0.0.1'
export const STAGING_ENVIRONMENT = 'staging'
export const STAGING_DOMAIN = 'canvasprints-dev.myshopify.com'
export const PRODUCTION_ENVIRONMENT = 'production'
export const PRODUCTION_DOMAIN = 'canvasprints.com'
export const IMAGE_UPLOAD_ERROR = 'image_upload_error'